import { useState } from 'react'
import { useAuth } from '../../App'
import { supabase } from '../../lib/supabase'
import { saveMemoryAnchor } from '../../lib/memoryAnchors'
import { localDayISO } from '../../lib/localDay'
import { Button, Modal } from '../ui'

export default function HomeMemorySheet({ fragrance, onClose, onSaved }) {
  const { user } = useAuth()
  const [title, setTitle] = useState('')
  const [note, setNote] = useState('')
  const [date, setDate] = useState(localDayISO)
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')

  const save = async event => {
    event.preventDefault()
    if (saving || !title.trim()) return
    setSaving(true)
    setError('')
    try {
      await saveMemoryAnchor(supabase, { userId: user?.id, fragranceId: fragrance.id, title, note, date })
      onSaved()
    } catch (err) {
      setError(err.message || 'Could not save memory. Please try again.')
      setSaving(false)
    }
  }

  return (
    <Modal open onClose={saving ? () => {} : onClose} title="Add a memory" maxWidth="max-w-sm" fullScreenMobile bodyClassName="overflow-x-hidden scroll-pb-24">
      <form onSubmit={save} className="min-w-0 space-y-3 pb-24 sm:pb-1">
        <p className="text-sm text-gold">{fragrance.name}</p>
        <label className="block text-xs text-cream/65">Memory title
          <input required maxLength={120} value={title} onChange={event => setTitle(event.target.value)} className="input mt-1 w-full" />
        </label>
        <label className="block text-xs text-cream/65">Note (optional)
          <textarea rows={2} value={note} onChange={event => setNote(event.target.value)} className="input mt-1 w-full" />
        </label>
        <label className="block text-xs text-cream/65">Date
          <input type="date" value={date} onChange={event => setDate(event.target.value)} className="input mt-1 w-full" />
        </label>
        {error && <p role="alert" className="text-xs text-red-300">{error}</p>}
        <Button type="submit" disabled={saving || !title.trim()} className="w-full">{saving ? 'Saving…' : 'Save memory'}</Button>
      </form>
    </Modal>
  )
}
